import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';

import { OverlayModule, OverlayRef } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LetDirective } from '@ngrx/component';
import { take, takeUntil } from 'rxjs/operators';
import { InstallationItem } from '../../../../projects/client';
import { ViIconButtonComponent } from '../../../../projects/ui';
import { InstallationsStore, ServiceTicket, ServiceTicketStore } from '../../../@store';
import { CommonStandaloneModule } from '../../common-standalone.module';
import { SERVICE_TICKET_OVERLAY_IT } from '../service-ticket';
import { ServiceTicketPageArticlesComponent } from './service-ticket-page-articles/service-ticket-page-articles.component';
import { ServiceTicketPageCallComponent } from './service-ticket-page-call/service-ticket-page-call.component';
import { ServiceTicketPageCreateComponent } from './service-ticket-page-create/service-ticket-page-create.component';
import { Subject } from 'rxjs';
import { ServiceTicketScrollService } from '../service-ticket-scroll.service';

@Component({
  selector: 'app-service-ticket-overlay',
  templateUrl: './service-ticket-overlay.component.html',
  styleUrls: ['./service-ticket-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonStandaloneModule,
    MatIconModule,
    OverlayModule,
    PortalModule,
    LetDirective,
    ViIconButtonComponent,
    RouterLinkActive,
    RouterLink,
    MatProgressBarModule,
    ServiceTicketPageCreateComponent,
    ServiceTicketPageCallComponent,
    ServiceTicketPageArticlesComponent,
  ],
  providers: [ServiceTicketScrollService],
})
export class ServiceTicketOverlayComponent implements OnInit, OnDestroy {
  ServiceTicketPage = ServiceTicket.ServiceTicketPage;

  private ngUnsubscribe$: Subject<void> = new Subject();

  constructor(
    public serviceTicketStore: ServiceTicketStore,
    @Inject(SERVICE_TICKET_OVERLAY_IT) private overlayRef: OverlayRef,
    private installationsStore: InstallationsStore,
    private serviceTicketScrollService: ServiceTicketScrollService,
    public elRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.installationsStore.installations$
      .pipe(take(1))
      .subscribe((installations: InstallationItem[]) => {
        if (!(installations?.length > 0)) {
          this.installationsStore.listInstallations();
        }
      });

    this.serviceTicketScrollService.scrollTop$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(() => {
        this.elRef.nativeElement.scrollTop = 0;
      });
  }

  closeOverlay(): void {
    this.serviceTicketStore.closeServiceTicket();
    this.overlayRef.detach();
  }

  navigateBackToCreatePage(): void {
    this.serviceTicketStore.navigateBackToCreatePage();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
